import axios from "axios";
import { AES, enc } from 'crypto-js';
import "./InviteRegister.css";
import Modal from "react-modal";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { toast } from "react-toastify";
import { useDispatch } from 'react-redux';
import { DatePicker } from "rsuite";
import 'react-phone-number-input/style.css';
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from 'react-phone-number-input';
import Type from "../../../images/icons/type.svg";
import Cost from "../../../images/icons/cost.svg";
import Tele from "../../../images/icons/tele.svg";
import Countries from "../../../constants/countries";
import userTypeName from "../../../constants/userType";
import EmailIcon from "../../../images/icons/email.svg";
import PassLock from "../../../images/icons/pass_lock.svg";
import Tick from "../../../images/icons/tick-arrow.svg";
import Company from "../../../images/icons/company.svg";
import Payment from "../../../images/icons/payment.svg";
import EyeIcon from "../../../images/icons/eye-icon.svg";
import location from "../../../images/icons/location.svg";
import JobTitle from "../../../images/icons/job-title.svg";
import Currencies from "../../../constants/currenciesList";
import React, { useEffect, useRef, useState, createRef } from "react";
import typeOfContract from "../../../constants/typeOfContract";
import PostalCode from "../../../images/icons/postal-code.svg";
import PassportlIcon from "../../../images/icons/passport.svg";
import birthIcon from "../../../images/icons/dat-of-birth.svg";
import EyeCrossed from "../../../images/icons/eye-crossed.svg";
import userCategoryName from "../../../constants/userCategory";
import { Link, useNavigate, useParams } from "react-router-dom";
import { logout, reset } from "../../../features/auth/authSlice";
import profile_image from "../../../images/user/Default_pfp.png";
import PicEdit from "../../../images/icons/profile-pic-edit.svg";
import UserIcon from "../../../images/icons/single-user-icon.svg";
import TypeContact from "../../../images/icons/type-of-contact.svg";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
import { getBrandLogo, getBrandLogoAlt } from "../../../utils/brandLogo";

// Skeleton loader styles
const skeletonStyle = {
  backgroundColor: "#e5e7eb",
  borderRadius: "4px",
  animation: "pulse 1.5s ease-in-out infinite",
};

// Edit Icon Skeleton (for upload photo link)
const EditIconSkeleton = () => (
  <div
    style={{
      width: "18px",
      height: "18px",
      borderRadius: "4px",
      ...skeletonStyle,
    }}
  />
);

// Button Skeleton (for Save changes button)
const ButtonSkeleton = ({ width = "140px", height = "44px" }) => (
  <div
    style={{
      width: width,
      height: height,
      backgroundColor: "#e5e7eb",
      borderRadius: "6px",
      animation: "pulse 1.5s ease-in-out infinite",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
    }}
  >
    <div
      style={{
        width: "100px",
        height: "18px",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        borderRadius: "4px",
        animation: "pulse 1.5s ease-in-out infinite",
      }}
    />
  </div>
);

export default function InviteRegisteration() {
  const dispatch = useDispatch();
  const { email, usertype, encodedAppId } = useParams();
  const fileInputRef = useRef(null);
  const [userCategory, setUserCategory] = useState(userCategoryName.Individual);
  const [userType, setUserType] = useState(usertype);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyFirstName, setCompanyFirstName] = useState("");
  const [companyLastName, setCompanyLastName] = useState("");
  const [wxComapny, setWxComapny] = useState("");
  const [dept, setDept] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [contract, setContract] = useState("");
  const [currency, setCurrency] = useState("");
  const [cost, setCost] = useState("");
  const [overheadCost, setOverheadCost] = useState("");
  const [vat, setVat] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [profileImageName, setProfileImageName] = useState(null);
  const [dob, setDob] = useState("");
  const [passport, setPassport] = useState("");
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [vatId, setVatId] = useState("");
  const [registrationDocument, setRegistrationDocument] = useState(null);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [postCode, setPostCode] = useState("");
  const [address, setAddress] = useState("");
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [fileSelectIsLoading, setFileSelectIsLoading] = useState(false);
  const [countrySearchTerm, setCountrySearchTerm] = useState('');
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [stateSearchTerm, setStateSearchTerm] = useState('');
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const cropperRef = createRef();
  const [roleId, setRoleId] = useState([]);
  const [wXCompany, setWXCompany] = useState([]);
  const [userDept, setUserDept] = useState([]);
  const [typeContract, setTypeContract] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [passwordMatchError, setPasswordMatchError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const passwordConfirmationRef = useRef(null);
  const passwordRef = useRef(null);
  const countryDropdownRef = useRef(null);
  const stateDropdownRef = useRef(null);
  const decodedEmail = decodeURIComponent(
    atob(email.replace(/\-/g, "+").replace(/_/g, "/"))
  );
  const decodedAppId = decodeURIComponent(encodedAppId.replace(/%2F/g, '/'));
  const decryptedBytes = AES.decrypt(decodedAppId, 'encryptionKey');
  const appId = decryptedBytes.toString(enc.Utf8);
  const url = new URL(window.location.href);
  const subdomain = url.hostname.split('.')[0];
  const capitalizedSubdomain = subdomain.charAt(0).toUpperCase() + subdomain.slice(1);
  const navigate = useNavigate();
  useEffect(() => {
    const verifyResetPassLink = async () => {
      const { email } = { email: decodedEmail };
      try {
        const response = await axios.post("/api/user/check/user-invite/validity", { email });
        if (response.data.status === "emailAlreadyRegistered") {
          // Reset link expired, redirect to forget-password page with alert message
          toast.error("This email is already registered.!!!", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
        }
        if (response.data.status === "linkExpired") {
          // Reset link expired, redirect to forget-password page with alert message
          toast.error("Sorry!.Invite link expired", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
        }
      } catch (error) {
        console.error(error);
        global.config.slackMessage(error.toString());
        toast.error("Something went wrong while verifying the reset link");
      }
    };
    verifyResetPassLink();

    async function fetchRoleId() {
      try {
        const response = await axios.get("/api/user-type");
        setRoleId(
          response.data.filter(
            (role) =>
              role._id !== userTypeName.Collaborator &&
              role._id !== userTypeName.Business
          )
        );
      } catch (error) {
        console.log(error);
        global.config.slackMessage(error.toString());
        if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        }
        alert("Something went wrong");
      }
    }
    fetchRoleId();

    async function fetchWXCompany() {
      try {
        const response = await axios.get("/api/get-wx-comapies");
        setWXCompany(response.data);
      } catch (error) {
        console.log(error);
        global.config.slackMessage(error.toString());
        if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        }
        alert("Something went wrong");
      }
    }

    fetchWXCompany();

    async function fetchUserDept() {
      try {
        const response = await axios.get("/api/user-department");
        setUserDept(response.data);
      } catch (error) {
        console.log(error);
        global.config.slackMessage(error.toString());
        if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        }
        alert("Something went wrong");
      }
    }
    fetchUserDept();

    async function fetchTypeContract() {
      try {
        const response = await axios.get("/api/contract-type");
        setTypeContract(response.data);
      } catch (error) {
        console.log(error);
        global.config.slackMessage(error.toString());
        if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        }
        alert("Something went wrong");
      }
    }
    fetchTypeContract();

    setCurrencyList(Currencies.sourceCurrencies[0].targetCurrencies);
    const sortedCountries = Countries.slice().sort((a, b) => a.country.localeCompare(b.country));
    setCountriesList(sortedCountries);

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        document.activeElement.blur();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitLoading(true);
    const s3errors = {};
    if (!password) s3errors.password = true;
    if (!passwordConfirmation) s3errors.passwordConfirmation = true;
    if (Object.keys(s3errors).length > 0) {
      setStep3Errors(s3errors);
      setIsSubmitLoading(false);
      return;
    }
    const mobileNoRegex = /^[+\d]+$/;
    if (!mobileNoRegex.test(mobileNo)) {
      toast.error("It's not a valid phone number", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setIsSubmitLoading(false);
      return;
    }
    if (password !== passwordConfirmation) {
      setStep3Errors({ passwordConfirmation: true });
      setPasswordMatchError("Passwords do not match");
      toast.error("Passwords do not match", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      passwordConfirmationRef.current.focus();
      setIsSubmitLoading(false);
      return;
    }
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#\$%\^&\*\(\)_\+\-\.\/:;<=>?@[\\\]^_`{|}~])[A-Za-z\d!@#\$%\^&\*\(\)_\+\-\.\/:;<=>?@[\\\]^_`{|}~]{8,}$/;
    if (!passwordRegex.test(password)) {
      setStep3Errors((prev) => ({ ...prev, password: true }));
      setPasswordError("Invalid password format");
      toast.error("Password must be at least 8 charachters long and include atleast one uppercase letter ,one lowercase letter,one digit and one special character from the set !@#$%^&*()_+,-/:;<=>?@_'[\]{|}~", {
        position: "bottom-right",
        autoClose: 3800,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      passwordRef.current.focus();
      setIsSubmitLoading(false);
      return;
    }

    const fileExtension = profileImageName
      ? profileImageName.name.split(".").pop()
      : "";
    const uniqueSuffix = Date.now() + "-" + Math.round(Math.random() * 1e9);
    const profile_img_fileName = profileImageName
      ? `${profileImageName.name
        .split(".")
        .shift()}_${uniqueSuffix}.${fileExtension}`
      : null;
    const requestData = {

      first_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? "" : firstName,
      middle_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? "" : middleName,
      last_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? "" : lastName,
      user_wx_comapny: "65125c1d4845bcfc83c5bf13",
      email: decodedEmail,
      mobile_no: mobileNo,
      passport_no: passport,
      password,
      user_category: userCategory,
      role_id: userType,
      department: "6466ffa5efdb9ea1084d88c7",
      typeOfContract: "64670fbe6cb18be88f7cc3bc",
      job_title: "",
      payment_currency: "USD",
      cost: 0,
      overHeadCostType: "65dd73c74c4587f420433d5d",
      overhead_cost: 0,
      vat: 0,
      address,
      pincode: postCode,
      dob,
      country,
      state,
      city,
      company_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? companyName : "",
      company_first_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? companyFirstName : "",
      company_last_name: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? companyLastName : "",
      vat_number: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? vatId : "",
      register_number: [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userCategory) ? registrationNumber : "",
      profile_image: profile_img_fileName,
      appId,
      registrationByInvite: true,
    };

    if (!requestData.appId) {
      toast.error("Something went wrong with the appId", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setIsSubmitLoading(false);
      return;
    }

    // Create a new FormData object
    const formData = new FormData();
    // Append the profile image to the form data
    formData.append("company_document", registrationDocument);

    // Append the other request data to the form data
    for (let key in requestData) {
      formData.append(key, requestData[key]);
    }

    try {
      const response = await axios.post("/api/user", formData);
      const data = response.data;
      if (data.status === "exists") {
        toast.warning("User with this email id already exists", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (data.status === "error") {
        console.log(data);
        toast.error("Something went wrong1", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        setIsSuccess(true);
      }

      if (profileImage) {
        const resizedImage = await resizeImage(profileImage, 500);
        const base64Image = resizedImage.split(',')[1];
        const blob = await fetch(`data:image/png;base64,${base64Image}`).then(res => res.blob());

        const formData = new FormData();
        formData.append("profile_image", blob, profile_img_fileName);

        try {
          const response = await axios.post("/api/uploads/profileImage", formData);
        } catch (error) {
          console.log(error);
          global.config.slackMessage(error.toString());
          alert("Something went wrong");
        }
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      alert("Something went wrong");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleProfilePicChange = () => {
    setFileSelectIsLoading(true);
    // Open file input dialog
    fileInputRef.current.click();
  };

  const handleFileInputCancel = () => {
    setFileSelectIsLoading(false);
  };

  useEffect(() => {
    const inputElement = fileInputRef.current;

    const handleChange = () => {
      handleFileInputChange({ target: { files: inputElement.files } });
    };

    const handleCancel = () => {
      handleFileInputCancel();
    };

    inputElement.addEventListener('change', handleChange);
    inputElement.addEventListener('cancel', handleCancel);

    return () => {
      inputElement.removeEventListener('change', handleChange);
      inputElement.removeEventListener('cancel', handleCancel);
    };
  }, []);

  const handleFileInputChange = (event) => {
    setFileSelectIsLoading(false);
    const file = event.target.files[0];
    setProfileImageName(event.target.files[0])
    if (file) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        setImage(fileReader.result);
        setModalIsOpen(true);
      };
      fileReader.readAsDataURL(file);
    }
  };

  const closeModal = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setFileSelectIsLoading(false);
    setModalIsOpen(false);
  };

  const handleCountrySearchInputChange = (e) => {
    setCountrySearchTerm(e.target.value);
  };

  const filteredCountries = countriesList.filter((country) => {
    return country.country.toLowerCase().includes(countrySearchTerm.toLowerCase());
  });

  const handleStateSearchInputChange = (e) => {
    setStateSearchTerm(e.target.value);
  };

  const selectedCountry = countriesList.find((c) => c.country === country);
  const filteredStates = selectedCountry?.states?.filter((stateObj) =>
    stateObj.state.toLowerCase().includes(stateSearchTerm.toLowerCase())
  );

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideCountryDropdown = countryDropdownRef.current && countryDropdownRef.current.contains(event.target);
    const isClickInsideStateDropdown = stateDropdownRef.current && stateDropdownRef.current.contains(event.target);
    if (!isClickInsideCountryDropdown) {
      setCountryDropdownOpen(false);
    }
    if (!isClickInsideStateDropdown) {
      setStateDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDropdown);
    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);

  const handleCropClick = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      const croppedImage = (cropperRef.current?.cropper.getCroppedCanvas().toDataURL());
      setUploadedImageUrl(croppedImage);
      setProfileImage(croppedImage);
    }
    closeModal();
  };

  // Function to resize the image
  const resizeImage = async (base64Image, maxWidth) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = base64Image;

      image.onload = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const aspectRatio = image.width / image.height;
        const newHeight = maxWidth / aspectRatio;

        canvas.width = maxWidth;
        canvas.height = newHeight;

        context.drawImage(image, 0, 0, maxWidth, newHeight);

        const resizedImage = canvas.toDataURL('image/jpeg'); // Change to 'image/png' if needed
        resolve(resizedImage);
      };
    });
  };

  const allowedExtensions = ["pdf", "doc", "docx", "msword", "xls", "xlsx", "csv"];
  const handleRegistrationDocChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
      if (allowedExtensions.includes(fileExtension)) {
        setRegistrationDocument(selectedFile);
      } else {
        toast.error("Invalid file format. Allowed formats are pdf, doc, docx, msword, xls, xlsx, csv.!!", {
          position: "bottom-right",
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // Optionally, you can clear the input
        event.target.value = null;
      }
    }
  };
  const countryData = countriesList.find((c) => c.country === country);
  const states = countryData?.states || [];
  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur()

    // Prevent the page/container scrolling
    e.stopPropagation()

    setTimeout(() => {
      e.target.focus()
    }, 0)
  }

  const [currentStep, setCurrentStep] = useState(1);
  const [isSuccess, setIsSuccess] = useState(false);
  const [step1Errors, setStep1Errors] = useState({});
  const [step2Errors, setStep2Errors] = useState({});
  const [step3Errors, setStep3Errors] = useState({});

  const handleStep1Continue = (e) => {
    e.preventDefault();
    const isIndividual = userCategory === "" || userCategory === userCategoryName.Individual;
    const errors = {};
    if (isIndividual) {
      if (!firstName.trim()) errors.firstName = true;
      if (!lastName.trim()) errors.lastName = true;
    } else {
      if (!companyName.trim()) errors.companyName = true;
      if (!companyFirstName.trim()) errors.companyFirstName = true;
      if (!registrationNumber.trim()) errors.registrationNumber = true;
    }
    if (!dob) errors.dob = true;
    if (!passport.trim()) errors.passport = true;
    setStep1Errors(errors);
    if (Object.keys(errors).length > 0) return;
    setCurrentStep(2);
  };

  const handleStep2Continue = (e) => {
    e.preventDefault();
    const errors = {};
    if (!address.trim()) errors.address = true;
    if (!city.trim()) errors.city = true;
    if (!country) errors.country = true;
    if (!mobileNo.trim()) errors.mobileNo = true;
    setStep2Errors(errors);
    if (Object.keys(errors).length > 0) return;
    setCurrentStep(3);
  };

  const StepIcon = ({ stepNum }) => {
    const isActive = currentStep === stepNum;
    const isDone = currentStep > stepNum;
    const circleStroke = (isActive || isDone) ? "#6479F8" : "#C2C8D0";
    const circleFill = isDone ? "#6479F8" : "none";
    const checkStroke = isDone ? "#fff" : (isActive ? "#6479F8" : "#C2C8D0");
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 27 27" fill="none">
        <circle cx="13.5" cy="13.5" r="12.5" stroke={circleStroke} strokeWidth="2" fill={circleFill}/>
        <path d="M8 13.2667L11.8261 17L19 10" stroke={checkStroke} strokeWidth="2"/>
      </svg>
    );
  };

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
      <div className="invite-register-page">
        {/* Left Sidebar */}
        <div className="invite-register-sidebar">
          <div className="invite-sidebar-logo">
            <img src={getBrandLogo()} alt={getBrandLogoAlt()} />
          </div>
          <div className="invite-sidebar-steps">
            <div className={`invite-step-item ${currentStep === 1 ? 'active' : ''}`}>
              <div className="invite-step-icon"><StepIcon stepNum={1} /></div>
              <div className="invite-step-text">
                <div className="invite-step-title">Your personal details</div>
                <div className="invite-step-subtitle">Please provide your profile details.</div>
              </div>
            </div>
            <div className={`invite-step-item ${currentStep === 2 ? 'active' : ''}`}>
              <div className="invite-step-icon"><StepIcon stepNum={2} /></div>
              <div className="invite-step-text">
                <div className="invite-step-title">Account information</div>
                <div className="invite-step-subtitle">Please provide your account details.</div>
              </div>
            </div>
            <div className={`invite-step-item ${currentStep === 3 ? 'active' : ''}`}>
              <div className="invite-step-icon"><StepIcon stepNum={3} /></div>
              <div className="invite-step-text">
                <div className="invite-step-title">Security</div>
                <div className="invite-step-subtitle">Select your security preferences</div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Content */}
        <div className="invite-register-content">
          <input
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            ref={fileInputRef}
          />
          <Modal
            isOpen={modalIsOpen}
            contentLabel="Image Crop Modal"
            style={{
              content: {
                height: "500%",
                width: "1000%",
                position: "fixed",
                top: "20%",
                left: "50%",
                parent: document.querySelector(".admin-outer.time.tracker"),
              },
            }}
          >
            <div>
              {image && (
                <Cropper
                  ref={cropperRef}
                  style={{ height: 400, width: "100%" }}
                  zoomTo={0}
                  initialAspectRatio={1}
                  preview=".img-preview"
                  src={image}
                  viewMode={1}
                  minCropBoxHeight={10}
                  minCropBoxWidth={10}
                  background={false}
                  responsive={true}
                  autoCropArea={100}
                  checkOrientation={false}
                  guides={true}
                />
              )}
            </div>
            <div>
              <div className="crop-btn">
                <button onClick={handleCropClick}>Crop and Upload</button>
                <button className="delete-client" onClick={closeModal}>Cancel</button>
              </div>
            </div>
          </Modal>

          {/* Step 1: Your Profile */}
          {currentStep === 1 && (
            <form onSubmit={handleStep1Continue} className="invite-step-form" noValidate>
              <h2 className="invite-form-title">Your Profile</h2>

              <div className="invite-field">
                <label className="invite-label">User Category*</label>
                <div className="invite-radio-group">
                  {Object.keys(userCategoryName)
                    .filter((key) => key !== 'Vendor' && key !== 'Client')
                    .map((key) => (
                      <div key={userCategoryName[key]} className="invite-radio-option">
                        <input
                          type="radio"
                          id={userCategoryName[key]}
                          value={userCategoryName[key]}
                          checked={userCategory === userCategoryName[key]}
                          onChange={() => setUserCategory(userCategoryName[key])}
                          required
                        />
                        <label htmlFor={userCategoryName[key]}>{key}</label>
                      </div>
                    ))}
                </div>
              </div>

              {(userCategory === userCategoryName.Business ||
                userCategory === userCategoryName.Vendor ||
                userCategory === userCategoryName.Client) && (
                <>
                  <div className="invite-field">
                    <label className="invite-label" htmlFor="reg-compname">Company Name*</label>
                    <input className={`invite-input${step1Errors.companyName ? ' invite-input-error' : ''}`} type="text" id="reg-compname" value={companyName} onChange={(e) => { setCompanyName(e.target.value); setStep1Errors((p) => ({ ...p, companyName: false })); }} required />
                    {step1Errors.companyName && <span className="invite-field-error">This field is required</span>}
                  </div>
                  <div className="invite-field">
                    <label className="invite-label" htmlFor="reg-compfname">First Name*</label>
                    <input className={`invite-input${step1Errors.companyFirstName ? ' invite-input-error' : ''}`} type="text" id="reg-compfname" value={companyFirstName} onChange={(e) => { setCompanyFirstName(e.target.value); setStep1Errors((p) => ({ ...p, companyFirstName: false })); }} required />
                    {step1Errors.companyFirstName && <span className="invite-field-error">This field is required</span>}
                  </div>
                  <div className="invite-field">
                    <label className="invite-label" htmlFor="reg-complname">Last Name</label>
                    <input className="invite-input" type="text" id="reg-complname" value={companyLastName} onChange={(e) => setCompanyLastName(e.target.value)} />
                  </div>
                  <div className="invite-field">
                    <label className="invite-label" htmlFor="reg-regnum">Registration Number*</label>
                    <input className={`invite-input${step1Errors.registrationNumber ? ' invite-input-error' : ''}`} type="text" id="reg-regnum" value={registrationNumber} onChange={(e) => { setRegistrationNumber(e.target.value); setStep1Errors((p) => ({ ...p, registrationNumber: false })); }} required />
                    {step1Errors.registrationNumber && <span className="invite-field-error">This field is required</span>}
                  </div>
                </>
              )}

              <div className="invite-field">
                <label className="invite-label" htmlFor="reg-fname">First Name*</label>
                <input
                  className={`invite-input${step1Errors.firstName ? ' invite-input-error' : ''}`}
                  type="text"
                  id="reg-fname"
                  value={firstName}
                  onChange={(e) => { setFirstName(e.target.value); setStep1Errors((p) => ({ ...p, firstName: false })); }}
                  required
                />
                {step1Errors.firstName && <span className="invite-field-error">This field is required</span>}
              </div>

              <div className="invite-field">
                <label className="invite-label" htmlFor="reg-lname">Last Name*</label>
                <input
                  className={`invite-input${step1Errors.lastName ? ' invite-input-error' : ''}`}
                  type="text"
                  id="reg-lname"
                  value={lastName}
                  onChange={(e) => { setLastName(e.target.value); setStep1Errors((p) => ({ ...p, lastName: false })); }}
                  required
                />
                {step1Errors.lastName && <span className="invite-field-error">This field is required</span>}
              </div>

              <div className="invite-field">
                <label className="invite-label" htmlFor="reg-email">Email*</label>
                <input
                  className="invite-input"
                  type="email"
                  id="reg-email"
                  value={decodedEmail}
                  readOnly
                  required
                />
              </div>

              <div className="invite-field">
                <label className="invite-label">Date of Birth*</label>
                <div className={`invite-dob-wrapper${step1Errors.dob ? ' invite-dob-error' : ''}`}>
                  <DatePicker
                    oneTap
                    value={dob ? new Date(dob) : null}
                    onChange={(date) => { setDob(date); setStep1Errors((p) => ({ ...p, dob: false })); }}
                    required
                    format="dd/MM/yyyy"
                    placeholder=""
                  />
                  <span className="invite-cal-icon" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="2" y="4" width="16" height="14" rx="2" stroke="#6479F8" strokeWidth="1.5"/>
                      <path d="M2 8H18" stroke="#6479F8" strokeWidth="1.5"/>
                      <path d="M6 2V5" stroke="#6479F8" strokeWidth="1.5" strokeLinecap="round"/>
                      <path d="M14 2V5" stroke="#6479F8" strokeWidth="1.5" strokeLinecap="round"/>
                      <rect x="5.5" y="11" width="2" height="2" rx="0.5" fill="#6479F8"/>
                      <rect x="9.5" y="11" width="2" height="2" rx="0.5" fill="#6479F8"/>
                      <rect x="13.5" y="11" width="2" height="2" rx="0.5" fill="#6479F8"/>
                      <rect x="5.5" y="14" width="2" height="2" rx="0.5" fill="#6479F8"/>
                      <rect x="9.5" y="14" width="2" height="2" rx="0.5" fill="#6479F8"/>
                    </svg>
                  </span>
                </div>
                {step1Errors.dob && <span className="invite-field-error">This field is required</span>}
              </div>

              <div className="invite-field">
                <label className="invite-label" htmlFor="reg-passport">Passport or ID Number*</label>
                <input
                  className={`invite-input${step1Errors.passport ? ' invite-input-error' : ''}`}
                  type="text"
                  id="reg-passport"
                  value={passport}
                  onChange={(e) => { setPassport(e.target.value); setStep1Errors((p) => ({ ...p, passport: false })); }}
                  required
                />
                {step1Errors.passport && <span className="invite-field-error">This field is required</span>}
              </div>

              <div className="invite-form-actions">
                <button type="submit" className="invite-continue-btn">
                  Continue
                </button>
              </div>
            </form>
          )}

          {/* Step 2: Account Information */}
          {currentStep === 2 && (
            <form onSubmit={handleStep2Continue} className="invite-step-form" noValidate>
              <h2 className="invite-form-title">Account information</h2>

              {/* Address */}
              <div className="invite-field">
                <label className="invite-label" htmlFor="reg-address">Address*</label>
                <input className={`invite-input${step2Errors.address ? ' invite-input-error' : ''}`} type="text" id="reg-address" value={address} onChange={(e) => { setAddress(e.target.value); setStep2Errors((p) => ({ ...p, address: false })); }} required />
                {step2Errors.address && <span className="invite-field-error">This field is required</span>}
              </div>

              {/* City */}
              <div className="invite-field">
                <label className="invite-label" htmlFor="reg-city">City*</label>
                <input className={`invite-input${step2Errors.city ? ' invite-input-error' : ''}`} type="text" id="reg-city" value={city} onChange={(e) => { setCity(e.target.value); setStep2Errors((p) => ({ ...p, city: false })); }} required />
                {step2Errors.city && <span className="invite-field-error">This field is required</span>}
              </div>

              {/* Country — full width dropdown */}
              <div className="invite-field">
                <label className="invite-label">Country*</label>
                <div className={`invite-select-wrap ${countryDropdownOpen ? 'open' : ''}${step2Errors.country ? ' invite-select-error' : ''}`} ref={countryDropdownRef}>
                  <div className="invite-select-trigger" onClick={() => setCountryDropdownOpen(!countryDropdownOpen)}>
                    <span className={country ? 'invite-select-value' : 'invite-select-placeholder'}>
                      {country || 'Select Country'}
                    </span>
                    <svg className="invite-select-chevron dropdown-chevron-icon" width="18" height="9" viewBox="0 0 18 9" fill="none">
                      <path d="M1.5 1.5L9 7.5L16.5 1.5" stroke="#405BFF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  {countryDropdownOpen && (
                    <div className="invite-select-dropdown">
                      <input
                        type="text"
                        className="invite-select-search"
                        placeholder="Search country..."
                        value={countrySearchTerm}
                        onChange={handleCountrySearchInputChange}
                        autoFocus
                      />
                      <ul>
                        {filteredCountries.map((c) => (
                          <li
                            key={c.country}
                            className={country === c.country ? 'selected' : ''}
                            onClick={() => { setCountry(c.country); setCountryDropdownOpen(false); setCountrySearchTerm(''); setStep2Errors((p) => ({ ...p, country: false })); }}
                          >
                            {c.country}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                {step2Errors.country && <span className="invite-field-error">This field is required</span>}
              </div>

              {/* State — shown only when country has states */}
              {states.length > 0 && (
                <div className="invite-field">
                  <label className="invite-label">State*</label>
                  <div className={`invite-select-wrap ${stateDropdownOpen ? 'open' : ''}`} ref={stateDropdownRef}>
                    <div className="invite-select-trigger" onClick={() => setStateDropdownOpen(!stateDropdownOpen)}>
                      <span className={state ? 'invite-select-value' : 'invite-select-placeholder'}>
                        {state || 'Select State'}
                      </span>
                      <svg className="invite-select-chevron dropdown-chevron-icon" width="18" height="9" viewBox="0 0 18 9" fill="none">
                        <path d="M1.5 1.5L9 7.5L16.5 1.5" stroke="#405BFF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    {stateDropdownOpen && (
                      <div className="invite-select-dropdown">
                        <input
                          type="text"
                          className="invite-select-search"
                          placeholder="Search state..."
                          value={stateSearchTerm}
                          onChange={handleStateSearchInputChange}
                          autoFocus
                        />
                        <ul>
                          {filteredStates.map((s) => (
                            <li
                              key={s.state}
                              className={state === s.state ? 'selected' : ''}
                              onClick={() => { setState(s.state); setStateDropdownOpen(false); setStateSearchTerm(''); }}
                            >
                              {s.state}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Postal Code */}
              <div className="invite-field">
                <label className="invite-label" htmlFor="reg-postal">Postal Code</label>
                <input className="invite-input" type="text" id="reg-postal" value={postCode} onChange={(e) => setPostCode(e.target.value)} />
              </div>

              {/* Mobile — full width */}
              <div className="invite-field">
                <label className="invite-label" htmlFor="reg-mobile">Mobile No.*</label>
                <input
                  className={`invite-input${step2Errors.mobileNo ? ' invite-input-error' : ''}`}
                  type="tel"
                  id="reg-mobile"
                  placeholder="Enter phone number"
                  value={mobileNo}
                  onChange={(e) => { setMobileNo(e.target.value); setStep2Errors((p) => ({ ...p, mobileNo: false })); }}
                  required
                />
                {step2Errors.mobileNo && <span className="invite-field-error">This field is required</span>}
              </div>

              {/* Business-only fields */}
              {(userCategory === userCategoryName.Business ||
                userCategory === userCategoryName.Vendor ||
                userCategory === userCategoryName.Client) && (
                <>
                  <div className="invite-field">
                    <label className="invite-label" htmlFor="reg-vatid">VAT ID*</label>
                    <input className="invite-input" type="text" id="reg-vatid" placeholder="VAT ID" value={vatId} onChange={(e) => setVatId(e.target.value)} required />
                  </div>
                  <div className="invite-field">
                    <label className="invite-label" htmlFor="reg-regdoc">Company Registration Document*</label>
                    <input className="invite-input" type="file" id="reg-regdoc" onChange={handleRegistrationDocChange} required />
                  </div>
                </>
              )}

              <div className="invite-form-actions invite-form-actions-two">
                <button type="button" className="invite-back-btn" onClick={() => setCurrentStep(1)}>Back</button>
                <button type="submit" className="invite-continue-btn">Continue</button>
              </div>
            </form>
          )}

          {/* Step 3: Security */}
          {currentStep === 3 && !isSuccess && (
            <form onSubmit={handleSubmit} className="invite-step-form" noValidate>
              <h2 className="invite-form-title">Security</h2>

              <div className="invite-field">
                <label className="invite-label" htmlFor="reg-email-s3">Email address</label>
                <input
                  className="invite-input"
                  type="email"
                  id="reg-email-s3"
                  value={decodedEmail}
                  readOnly
                />
              </div>

              <div className="invite-field">
                <label className="invite-label" htmlFor="reg-password">Password*</label>
                <div className="invite-input-wrap">
                  <input
                    className={`invite-input${step3Errors.password ? ' invite-input-error' : ''}`}
                    type={showPassword ? "text" : "password"}
                    id="reg-password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => { setPassword(e.target.value); setStep3Errors((p) => ({ ...p, password: false })); setPasswordError(""); }}
                    ref={passwordRef}
                  />
                  <img
                    src={showPassword ? EyeCrossed : EyeIcon}
                    className="password-toggle-icon"
                    alt="Toggle Password"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </div>
                {passwordError && <span className="invite-field-error">{passwordError}</span>}
                {!passwordError && step3Errors.password && <span className="invite-field-error">This field is required</span>}
              </div>

              <div className="invite-field">
                <label className="invite-label" htmlFor="reg-confpassword">Confirm Password*</label>
                <input
                  className={`invite-input${step3Errors.passwordConfirmation ? ' invite-input-error' : ''}`}
                  type="password"
                  id="reg-confpassword"
                  placeholder="Confirm Password"
                  value={passwordConfirmation}
                  onChange={(e) => { setPasswordConfirmation(e.target.value); setStep3Errors((p) => ({ ...p, passwordConfirmation: false })); setPasswordMatchError(""); }}
                  ref={passwordConfirmationRef}
                />
                {passwordMatchError && <span className="invite-field-error">{passwordMatchError}</span>}
                {!passwordMatchError && step3Errors.passwordConfirmation && <span className="invite-field-error">This field is required</span>}
              </div>

              <div className="invite-form-actions invite-form-actions-two">
                <button type="button" className="invite-back-btn" onClick={() => setCurrentStep(2)}>
                  Back
                </button>
                {isSubmitLoading ? (
                  <ButtonSkeleton width="200px" height="44px" />
                ) : (
                  <button type="submit" className="invite-continue-btn invite-complete-btn" disabled={isSubmitLoading}>
                    Complete onboarding
                  </button>
                )}
              </div>
            </form>
          )}

          {/* Success screen */}
          {isSuccess && (
            <div className="invite-step-form invite-success-screen">
              <h2 className="invite-success-title">You're all set!</h2>
              <p className="invite-success-message">
                Thank you for registering! Your account has been created. To access your Talenton account, please log in using your credentials.
              </p>
              <button className="invite-continue-btn invite-goto-btn" onClick={() => navigate("/")}>
                Go to my account
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}